import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  MANAGE_SUBS_RESET_CUSTOMER_DATA,
} from './constants';

export function resetCustomerData() {
  return {
    type: MANAGE_SUBS_RESET_CUSTOMER_DATA,
  };
}

export function useResetCustomerData() {
  const dispatch = useDispatch();
  const  customerData = useSelector(state => state.manageSubs.customerData);
  const boundAction = useCallback((...params) => dispatch(resetCustomerData(...params)), [dispatch]);
  return { customerData,resetCustomerData: boundAction };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_RESET_CUSTOMER_DATA:
      return {
        ...state,
        customerData: null,
      };

    default:
      return state;
  }
}
